import React, { useState, useEffect } from 'react'
import RightPanel from 'components/RightPanel/RightPanel'
import VendorList from 'features/Vendors/components/VendorList'
import AdminPanelCN from 'components/AdminPanelCN/AdminPanelCN'
import HeaderCN from 'components/HeaderCN/HeaderCN'
import Projects from './components/Projects/Projects'
import SidebarProjectsRecent from 'components/Sidebars/SidebarProjectsRecent'
import useIsMobile from 'hooks/useIsMobile'
import useIsPhone from 'hooks/useIsPhone'
import { Handshake } from 'lucide-react'
import MobileBackButton from 'components/MobileBackButton'

const CARD_DISPLAY_KEY = 'projectsCardDisplayPreference'

const Projects_IndexCN = () => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
	const isMobile = useIsMobile()
	const isPhone = useIsPhone()

	const [cardDisplay, setCardDisplay] = useState(() => {
		const stored = localStorage.getItem(CARD_DISPLAY_KEY)
		return stored === null ? true : stored === 'true'
	})

	useEffect(() => {
		localStorage.setItem(CARD_DISPLAY_KEY, String(cardDisplay))
	}, [cardDisplay])

	// Cards is not offered on phones (below 768px; tablets keep it since MYD-560).
	// Neither collection has a map, so on a phone there is
	// exactly one legal view and no toggle is rendered (see the component).
	//
	// The effect above persists the RAW preference, never this one — otherwise a
	// single phone visit would permanently overwrite the user's desktop choice.
	const effectiveCardDisplay = isPhone ? false : cardDisplay

	return (
		<div className="flex h-screen overflow-hidden bg-gray-50">
			<AdminPanelCN mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

			<div className="flex-1 flex flex-col overflow-hidden">
				<HeaderCN onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />

				<div className="flex-1 flex overflow-hidden">
					<main className="flex-1 overflow-y-auto p-6">
						{/* The close button self-gates on viewport, so this row is the same
						    shape on desktop with nothing rendered on the right. */}
						<div className="flex items-center justify-between gap-3 mb-4">
							<h2 className="text-2xl font-semibold text-gray-800">Projects</h2>
							<MobileBackButton mode="close" />
						</div>
						<Projects
							cardDisplay={effectiveCardDisplay}
							onToggleCardDisplay={() => setCardDisplay(!cardDisplay)}
							isMobile={isMobile}
							listOnly={isPhone}
						/>
					</main>

					<RightPanel storageKey="projects" label="Projects panel">
						<div className="flex flex-col h-1/2 border-b border-gray-200 overflow-y-auto">
							<SidebarProjectsRecent />
						</div>
						{/* Vendor Partnerships card — bottom half */}
						<div className="flex flex-col h-1/2">
							<div className="px-4 py-3 border-b border-gray-100">
								<span className="flex items-center gap-2 text-gray-600 text-base font-semibold hover:scale-105 transition-transform duration-150">
									<Handshake className="w-4 h-4" /> Vendor Partnerships
								</span>
							</div>
							<div className="flex-1 overflow-y-auto">
								<VendorList />
							</div>
						</div>
					</RightPanel>
				</div>
			</div>
		</div>
	)
}

export default Projects_IndexCN
